<template>
  <div></div>
</template>

<script>
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
import Cookies from "js-cookie";
import { TOKEN_KEY } from "@/utils/common";
export default {
  name: "wechat",
  data() {
    return {
      appid: "wxf27e60f5faa4cfdc",
      commonId: "",
      codeType: "",
      orgId: "",
      operateType: "", //是否审批
      roterPage: "",
    };
  },
  created() {
    this.commonId = this.$route.query.commonId || "";
    this.codeType = this.$route.query.codeType || "";
    this.operateType = this.$route.query.operateType || "";
    this.orgId = this.$route.query.orgId || "";
  },
  mounted() {
    this.getCode();
  },
  methods: {
    ...mapMutations(["setUserInfo", "setShowLoad"]),
    getCode() {
      // 非静默授权，第一次有弹框
      let _this = this;
      const code = _this.getQueryStringCollect("code"); // 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      const local = window.location.href;
      if (code == null || code === "") {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          _this.appid +
          "&redirect_uri=" +
          encodeURIComponent(local) +
          "&response_type=code&scope=snsapi_userinfo&state=" +
          new Date().getTime() +
          "#wechat_redirect";
      } else {
        this.getOpenId(code); //把code传给后台获取用户信息
      }
    },
    getOpenId(code) {
      let _this = this;

      _this.$api.userCenter.Wechat.getUserInfo({
        code: code,
        clientType: "app",
      })
        .then((res) => {
          if (res.code == "1") {
            Cookies.set(TOKEN_KEY, res.data.token);
            this.$nextTick(() => {
              if (_this.codeType == "dhShare") {
                window.location.href =
                  "https://www.ahdhst.com/OA-pageH5/#/dhShare?token=" +
                  res.data.token +
                  "&orgId=" +
                  _this.orgId;
              } else {
                _this.initUserInfo();
              }
            });
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    initUserInfo() {
      let _this = this;
      _this.$api.userCenter.user.myInfo
        .userMsg()
        .then((res) => {
          if (res.code == "1") {
            _this.setUserInfo(res.data);
            _this.checkAuditUser(res.data.id);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkAuditUser(uid) {
      let _this = this;
      _this.$api.flowPath.flow
        .getCheckAuditUser({
          applyId: _this.commonId,
          chartCode: _this.codeType,
          uid: uid,
        })
        .then((res) => {
          if (res.code == "1") {
            let timestamp = Date.parse(new Date());
            switch (_this.codeType) {
              case "qingjia": //请假
                _this.roterPage = "leaveApply";
                break;
              case "buka":
                //补卡
                _this.roterPage = "fillUpCard";
                break;
              case "chuchai":
                //出差
                _this.roterPage = "businessTripApply";
                break;
              case "chuchaibiangeng":
                //出差变更
                _this.roterPage = "businessChangeApply";
                break;
              case "huiyishi":
                //会议室申请
                _this.roterPage = "meetingApply";
                break;
              case "waichu":
                //外出
                _this.roterPage = "gooutApply";
                break;
              case "jiedai":
                //接待
                _this.roterPage = "receptionApply";
                break;
              case "jiaban":
                //加班
                _this.roterPage = "overTimeApply";
                break;
              case "lizhi":
                //离职
                _this.roterPage = "leaveOffice";
                break;
              case "zhuanzheng":
                //转正
                _this.roterPage = "promotionOffice";
                break;
              case "zhuanshiyong":
                //转试用
                _this.roterPage = "probationOffice";
                break;
              case "zhaopin":
                //招聘
                _this.roterPage = "recruitPage";
                break;
              case "qita":
                //其他
                _this.roterPage = "otherCapital";
                break;
              case "xiangmudengji":
                //项目登记
                _this.roterPage = "projectRegister";
                break;

              case "xiangmuchengguo":
                //项目成果出库
                _this.roterPage = "deliveryPage";
                break;
              case "jiekuan":
                //借款
                _this.roterPage = "loanApplication";
                break;
              case "baoxiao":
                //管理报销
                _this.roterPage = "reimbursement";
                break;
              case "putongbaoxiao":
                //普通报销
                _this.roterPage = "reimbursement";
                break;
              case "baoxiaoyijiao":
                //报销移交
                _this.roterPage = "handOver";
                break;
              case "baozhengjin":
                //保证金
                _this.roterPage = "marginApplication";
                break;
              case "yonghuzijin":
                //付款申请（现用资金申请）
                _this.roterPage = "capitalManage";
                break;
              case "guanliyonghuzijin":
                //管理付款（现用资金申请）
                _this.roterPage = "capitalManage";
                break;
              case "fukuanyijiao":
                //付款移交
                _this.roterPage = "capitalHandOver";
                break;
              case "kaipiaozuofei":
                //开票作废
                _this.roterPage = "myAbolishInvoice";
                break;
              case "kaipiao":
                //项目开票
                _this.roterPage = "invoiceManage";
                break;
              case "yongche":
                //用车
                _this.roterPage = "vehicleApply";
                break;
              case "yinzhang":
                //印章
                _this.roterPage = "sealApply";
                break;
              case "caigou":
                //采购
                _this.roterPage = "procurementManage";

                break;
              case "wuzi":
                //物资
                _this.roterPage = "materialApplication";

                break;
              case "wuziguihuan":
                //物资归还
                _this.roterPage = "goodsReturn";
                break;
              case "tongzhi":
                //通知
                _this.roterPage = "wxInformMsg";
                break;
              case "kaohejiangjin":
                //项目奖金申请
                _this.roterPage = "bonusManage";
                break;
              case "waipai":
                //外派培训申请
                _this.roterPage = "OverseasTrain";
                break;
              case "waipaileave":
                //培训请假申请
                _this.roterPage = "trainLeaveApply";
                break;
              case "wuzibaofei":
                //培训请假申请
                _this.roterPage = "materialScrapApply";
                break;
            }

            if (res.data) {
              //有权限可以审核

              window.location.href =
                "https://www.ahdhst.com/OA-pageH5/#/" +
                _this.roterPage +
                "?token=" +
                Cookies.get(TOKEN_KEY) +
                "&commonId=" +
                _this.commonId +
                "&orgId=" +
                _this.orgId +
                "&commonType=verify&verifyType=1&time=" +
                timestamp;
            } else {
              //没有审核权限 || 已经审核完毕

              window.location.href =
                "https://www.ahdhst.com/OA-pageH5/#/" +
                _this.roterPage +
                "?token=" +
                Cookies.get(TOKEN_KEY) +
                "&commonId=" +
                _this.commonId +
                "&orgId=" +
                _this.orgId +
                "&commonType=view&time=" +
                timestamp;
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getQueryStringCollect(retStr) {
      var reg = new RegExp("(^|&)" + retStr + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
  },
  computed: {
    ...mapState(["showLoad"]),
  },
};
</script>
 
<style lang="less">
</style>